module.exports = __webpack_public_path__ + "img/Tool.8346d874.svg";